import { match } from "ts-pattern";

import { cn } from "@/web/lib/styling";
import type { DefaultStage } from "@/web/routes/browse/-components/types";
import { useCampaignBrowserSearch } from "@/web/routes/browse/-components/useBrowse";

const TAB_LABELS: { id: "all" | DefaultStage; label: string }[] = [
  { id: "all", label: "All" },
  { id: "nomination", label: "Nominations" },
  { id: "roadshow", label: "Campaigns" },
  { id: "offering", label: "Offerings" },
];

export function BrowseStageTabs({ className }: { className?: string }) {
  const { search, setStageTab } = useCampaignBrowserSearch();

  const active: "all" | DefaultStage = match(search.stages?.[0])
    .with("nomination", "roadshow", "offering", (s) => s)
    .otherwise(() => "all");

  return (
    <div className={cn("relative", className)}>
      <div
        className="no-scrollbar flex items-end gap-6 overflow-x-auto pb-2 md:gap-8"
        role="tablist"
        aria-label="Campaign stage"
      >
        {TAB_LABELS.map(({ id, label }) => {
          const isActive = active === id;
          return (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={cn(
                "withus-strong relative shrink-0 cursor-pointer pb-2 text-xl tracking-wide transition-opacity md:text-2xl",
                isActive
                  ? "text-foreground opacity-100"
                  : "text-foreground opacity-20 hover:opacity-40",
              )}
              onClick={() => setStageTab(id)}
            >
              {label}
              {isActive ? (
                <span
                  className="absolute right-0 bottom-0 left-0 h-0.5 bg-withus-red"
                  aria-hidden
                />
              ) : null}
            </button>
          );
        })}
      </div>
      <div className="pointer-events-none absolute top-0 right-0 bottom-0 w-12 bg-gradient-to-l from-background to-transparent md:hidden" />
    </div>
  );
}
